// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'
// eslint-disable-next-line import/no-unresolved

class MediaGallery extends HTMLElement {
  static observedAttributes = ['aria-hidden']
  constructor () {
    super()
    this.interval = 0
    this.handleAutoplay = (run, instance) => {
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        if (run && instance) {
          instance.next()
        }
      }, 5000)
    }

    this.slidesEl = this.querySelector('[data-el="media-gallery.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="media-gallery.slide"]')
    this.thumbnailsEl = this.querySelector(
      '[data-el="media-gallery.thumbnails"]',
    )
    this.thumbnailEls = this.querySelectorAll(
      '[data-el="media-gallery.thumbnail"]',
    )
    this.dotEls = this.querySelectorAll('[data-el="media-gallery.dot"]')
    this.controlPrevEls = this.querySelectorAll(
      '[data-el="media-gallery.controlprevious"]',
    )
    this.controlNextEls = this.querySelectorAll(
      '[data-el="media-gallery.controlnext"]',
    )
    this.imagesEls = this.querySelectorAll('[data-el="media-gallery.image"]')
    this.videosEls = this.querySelectorAll('[data-el="media-gallery.video"]')

    if (this.slideEls.length < 2) return

    this.gallery = this.initialiseGallery()

    this.controlPrevEls.forEach(controlPrevEl =>
      controlPrevEl.addEventListener('click', this.handleArrowClick.bind(this)),
    )

    this.controlNextEls.forEach(controlNextEl =>
      controlNextEl.addEventListener('click', this.handleArrowClick.bind(this)),
    )

    window.addEventListener('resize', event => {
      this.slidesEl.style.width = null
      this.slidesEl.style.width = `${Math.floor(this.slidesEl.offsetWidth)}px`
    })

    setTimeout(() => {
      this.pinchCheck = this.initialisepinchCheck()
    }, 500)
  }

  initialiseGallery () {
    return new KeenSlider(this.slidesEl, {
      mode: 'snap',
      rtl: false,
      loop: true,
      controls: true,
      spacing: 1,
      slidesPerView: 1.4,
      slides: '.prd-Media_Slide',
      autoAdjustSlidesPerView: false,
      breakpoints: {
        '(min-width: 1201px)': {
          spacing: 0,
          slidesPerView: 2,
        },
      },
      created: () => {
        this.dataset.initialized = 'true'
        this.thumbnailEls.forEach(thumbnailEl => {
          thumbnailEl.addEventListener('click', this.handleDotClick.bind(this))
        })

        this.dotEls.forEach(dotEl => {
          dotEl.addEventListener('click', this.handleDotClick.bind(this))
        })

        this.slidesEl.style.width = `${Math.floor(this.slidesEl.offsetWidth)}px`
      },
      slideChanged: instance => {
        this.thumbnailEls.forEach(thumbnailEl => {
          thumbnailEl.setAttribute(
            'aria-current',
            parseInt(thumbnailEl.dataset.slide) ===
              instance.details().relativeSlide,
          )

          if (
            parseInt(thumbnailEl.dataset.slide) ===
            instance.details().relativeSlide
          ) {
            this.thumbnailsEl.scrollTo({
              top: thumbnailEl.offsetTop,
              left: 0,
              behavior: 'smooth',
            })
          }
        })

        this.dotEls.forEach(dotEl => {
          dotEl.setAttribute(
            'aria-current',
            parseInt(dotEl.dataset.slide) === instance.details().relativeSlide,
          )
        })

        this.gtmTrackGalleryProgress(instance.details())
      },
      move: instance => {
        this.slideEls.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide,
          )
        })
      },
    })
  }

  handleDotClick (event) {
    this.gallery.moveToSlide(event.target.dataset.slide)
  }

  handleArrowClick (event) {
    sessionStorage.setItem('BAO-media-gallery-arrow-click', 'true')

    if (event.currentTarget.dataset.direction === 'previous') {
      this.gallery.prev()
    } else {
      this.gallery.next()
    }
  }

  gtmTrackGalleryProgress (details) {
    if (details.progressTrack === 0) return

    const isArrowClick = sessionStorage.getItem('BAO-media-gallery-arrow-click')
    const eventType = isArrowClick ? 'arrow click' : 'drag'
    const targetContext = 'pdp-gallery'
    const eventProgress = this.calculateProgress(details)
    this.trackGalleryConversionAttribution(eventProgress)

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      event: 'carousel_engagement',
      event_type: eventType,
      event_progress: eventProgress,
      target_context: targetContext,
      target_contextSize: details.size,
    })

    if (!isArrowClick) return

    sessionStorage.removeItem('BAO-media-gallery-arrow-click')
  }

  calculateProgress (details) {
    const { relativeSlide, size, slidesPerView } = details

    const fullSlidesPerView = Math.floor(slidesPerView)
    const highestCurrentVisibleIndex = relativeSlide + fullSlidesPerView
    let percentageProgress = (highestCurrentVisibleIndex / size) * 100

    percentageProgress = percentageProgress > 100 ? 0 : percentageProgress

    return Math.round(percentageProgress / 10) * 10
  }

  trackGalleryConversionAttribution (percentageProgress) {
    const currentValue = sessionStorage.getItem('BAO-add-to-cart-event-context')
    const prefix = 'pdp-gallery-percentage-progress'

    if (currentValue === `${prefix}-76-100`) return

    let interactionProgress = `${prefix}-0-25`

    if (percentageProgress > 75) {
      interactionProgress = `${prefix}-76-100`
    } else if (percentageProgress > 50) {
      interactionProgress = `${prefix}-51-75`
    } else if (percentageProgress > 25) {
      interactionProgress = `${prefix}-26-50`
    }

    sessionStorage.setItem('BAO-add-to-cart-event-context', interactionProgress)
  }
}

customElements.define('media-gallery', MediaGallery)
